import { render } from "./ADDialog.vue?vue&type=template&id=2e84feb3"
import script from "./ADDialog.vue?vue&type=script&lang=js"
export * from "./ADDialog.vue?vue&type=script&lang=js"

import "./ADDialog.vue?vue&type=style&index=0&id=2e84feb3&lang=css"
script.render = render

export default script